__turbopack_context__.v({
  "buttonLink": "extra-promo-offer-module-scss-module__heAkhq__buttonLink",
  "cardImage": "extra-promo-offer-module-scss-module__heAkhq__cardImage",
  "container": "extra-promo-offer-module-scss-module__heAkhq__container",
  "content": "extra-promo-offer-module-scss-module__heAkhq__content",
  "icon-american-express": "extra-promo-offer-module-scss-module__heAkhq__icon-american-express",
  "icon-arrow": "extra-promo-offer-module-scss-module__heAkhq__icon-arrow",
  "icon-chat": "extra-promo-offer-module-scss-module__heAkhq__icon-chat",
  "icon-cross": "extra-promo-offer-module-scss-module__heAkhq__icon-cross",
  "icon-discover": "extra-promo-offer-module-scss-module__heAkhq__icon-discover",
  "icon-mastercard": "extra-promo-offer-module-scss-module__heAkhq__icon-mastercard",
  "icon-visa": "extra-promo-offer-module-scss-module__heAkhq__icon-visa",
  "location": "extra-promo-offer-module-scss-module__heAkhq__location",
  "phone": "extra-promo-offer-module-scss-module__heAkhq__phone",
  "subtitle": "extra-promo-offer-module-scss-module__heAkhq__subtitle",
  "supportingText": "extra-promo-offer-module-scss-module__heAkhq__supportingText",
  "title": "extra-promo-offer-module-scss-module__heAkhq__title",
  "trade-mark": "extra-promo-offer-module-scss-module__heAkhq__trade-mark",
});
